
export default [

  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'aptidao',
    label: 'Aptidão',
    valor: 'valor',
    tipo: 185,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-custom',
    field: 'exames',
    label: 'Informe os Exames Alterados (caso existir algum)',
    clearable: true,
    multiple: true,
    option: {
      label: 'nome',
      value: 'id'
    },
    rules: ['']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'select-tipo',
    field: 'id_tipo_status',
    label: 'Status',
    tipo: 53,
    rules: ['required']
  },
  {
    class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    type: 'textarea',
    field: 'obs',
    label: 'Observações',
    placeholder: 'Digite algo sobre a liberacao',
    rules: []
  },
];



// WEBPACK FOOTER //
// ./src/components/apps/web/consulta/liberacao/_form/liberacao-aso.js